module.exports = __webpack_public_path__ + "img/Frame-84.ecc0bbdf.svg";